export const API_URLs: { [key: string]: string } = {
    local: 'http://localhost:8001/',
    nqn: 'https://apis-nqn.tab-gestiones.com',
    indigo:  'https://api.financiera.tabsi.com.ar',
};


  
